exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1,h2{font-weight:400;margin:16px 0}p{line-height:32px;word-wrap:break-word}.gift_receive_root{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.gift_receive_description{margin-bottom:32px}.gift_receive_description svg{width:84px}.message_and_price{margin-bottom:20px}@media screen and (min-width:480px){.eth_gift_card{width:60%;margin:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3de3cf6b","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GiftReceive.vue
// module id = 77
// module chunks = 0